import { Box, Container, Typography, Grid, Card, CardActionArea, CardMedia, CardContent } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Footer from "../components/Footer";
import { NEWS, SITE_URL } from "../content/news";

export default function NewsListPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const items = [...NEWS].sort((a, b) => b.date.localeCompare(a.date));

    return (
        <Box>
            <Helmet>
                <title>{t("news.seoTitle")}</title>
                <meta name="description" content={t("news.seoDescription")} />
                <meta property="og:title" content={t("news.seoTitle")} />
                <meta property="og:description" content={t("news.seoDescription")} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`${SITE_URL}/novosti`} />
            </Helmet>

            <Box sx={{ minHeight: "calc(100vh - 64px)", bgcolor: "grey.100", py: { xs: 4, md: 6 } }}>
                <Container maxWidth="lg">
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
                        {t("news.title")}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                        {t("news.subtitle")}
                    </Typography>

                    <Grid container spacing={3}>
                        {items.map((item) => (
                            <Grid item xs={12} sm={6} md={4} key={item.slug}>
                                <Card sx={{ height: "100%", borderRadius: 3 }}>
                                    <CardActionArea
                                        component="a"
                                        href={`/novosti/${item.slug}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(`/novosti/${item.slug}`);
                                        }}
                                        sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.image}
                                            alt={item.imageAlt}
                                            loading="lazy"
                                            sx={{ aspectRatio: "3 / 2", objectFit: "cover" }}
                                        />
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography variant="caption" color="text.secondary">
                                                {dayjs(item.date).format("DD.MM.YYYY.")}
                                            </Typography>
                                            <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mt: 0.5, mb: 1, lineHeight: 1.3 }}>
                                                {item.title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.excerpt}
                                            </Typography>
                                            <Typography variant="body2" color="primary" sx={{ fontWeight: 700, mt: 2 }}>
                                                {t("news.readMore")}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            <Footer />
        </Box>
    );
}
